export function JSONReplacer(_key: string, value: unknown): unknown {
  return serialize(value);
}

export function serialize(value: unknown): unknown {
  if (value instanceof Error) {
    return {
      // カスタムエラーがdestructure可能なプロパティを持つ場合がある
      ...value,
      // Errorオブジェクトの標準プロパティは明示的に列挙する必要がある
      name: value.name,
      message: value.message,
      stack: value.stack,
      // causeはErrorオブジェクトである場合が多い
      cause: serialize(value.cause),
    };
  }

  return value;
}
